import IblJsClient from '@iblai/ibl-web-core-frontend';

const api = new IblJsClient(
  {
    IBL_API_PROXY_URL: process.env.REACT_APP_IBL_WEB_URL,
    IBL_LMS_URL: process.env.REACT_APP_IBL_LMS_URL,
    IBL_DM_URL: process.env.REACT_APP_IBL_DM_URL,
  },
  { errors: { 401: handleLogout } }
);

api.initiateAxdClientsWithAxdWebUrl(process.env.REACT_APP_IBL_AXD_URL);
api.isDirectAxdAuth = process.env.REACT_APP_IBL_IS_DIRECT_AXD_AUTH === 'true';
api.spaLoginPath = process.env.REACT_APP_IBL_SPA_LOGIN_PATH;

function handleLogout() {
  api.iblwebauth.logout({}, (logoutUrl) => {
    window.location.href = `${logoutUrl}?redirect_to=${process.env.REACT_APP_IBL_SPA_AUTH_URL}/logout?redirect-to=${window.location.origin}/logout`;
  });
}

export { api };
